import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initializeGA, setupHashChangeTracking } from './utils/analytics';

import reportWebVitals from './reportWebVitals';

// Initialize Google Analytics (production only)
initializeGA();

// Enable automatic section tracking for hash changes (#hero, #about, #services, #contact)
setupHashChangeTracking();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
